import { FC, MouseEventHandler } from "react";
import styles from "./index.module.scss";
import Info from "@/assets/images/Info";
import classNames from "classnames";

interface LabelProps {
  title: string;
  info?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  className?: string;
}

const Label: FC<LabelProps> = ({ title, info, onClick, className, ...rest }) => {
  return (
    <div
      className={classNames(styles.container, info && styles.infoContainer, className)}
      onClick={onClick}
      {...rest}>
      <span>{title}</span>
      {info && <Info width="16px" height="16px" className={styles.info} />}
    </div>
  );
};

export default Label;
